import React from 'react';

const IconChevronRight = () => {
    return (
        <svg className="icon-svg" style={{height: 24, width: 24}} preserveAspectRatio="xMidYMid meet" viewBox="0 0 100 100">
            <g>
                <polygon points="32.32 28.79 53.54 50 32.32 71.21 39.39 78.28 67.68 50 39.39 21.72 32.32 28.79" />
            </g>
        </svg>
    )
};

export default IconChevronRight;



// WEBPACK FOOTER //
// ./src/icons/icon-chevron-right.js